import { IUserRegisterRequest } from '../../../entity/interface/iSubscription';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';

export interface IUserRegisterUseCase {
    execute(language: string, payload: IUserRegisterRequest, apiToken: { [key: string]: string }): Promise<any>;
}

export class UserRegisterUseCase implements IUserRegisterUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(language: string, payload: IUserRegisterRequest, apiToken: { [key: string]: string }): Promise<any> {
        return await this.subscriptionRepository.userRegister(language, payload, apiToken);
    }
}
